import React from 'react';

import { NextPageWithLayout } from 'next';
import NextImage from 'next/image';

import { AppDownloadSection } from '../../../components/AppDownloadSection/AppDownloadSection';
import { Container } from '../../../components/Container/Container';
import { Heading } from '../../../components/Heading/Heading';
import { BlueCatchIcon } from '../../../components/Icons/BlueOnBlue/BlueCatchIcon';
import { BlueGPSIcon } from '../../../components/Icons/BlueOnBlue/BlueGPSIcon';
import { BlueTickIcon } from '../../../components/Icons/BlueOnBlue/BlueTickIcon';
import { MetaTags } from '../../../components/MetaTags/MetaTags';
import { Text } from '../../../components/Text/Text';
import { CircleImageAndText } from '../components/CircleImageAndText';

import phoneOne from './assets/phoneOne.png';
import phoneTwo from './assets/phoneTwo.png';
import { HeaderSection } from '../components/HeaderSection';
import {
  META_RULES_AND_REGULATIONS_TITLE,
  META_RULES_AND_REGULATIONS_DESCRIPTION,
  META_RULES_AND_REGULATIONS_CANONICAL,
} from '../../../constants/metadata';

export const RegulationsPage: NextPageWithLayout = () => {
  return (
    <div>
      <MetaTags
        title={META_RULES_AND_REGULATIONS_TITLE}
        description={META_RULES_AND_REGULATIONS_DESCRIPTION}
        link={META_RULES_AND_REGULATIONS_CANONICAL}
      />
      <HeaderSection
        headingText="Fishing regulations for the Unites States"
        bodyText="Fish without fear across the US. Quickly see which species you can fish for and the bag
          limit in your state."
        containerClassName="sm:mx-16"
        bodyClassName="md:w-col-8! sm:w-col-10 sm:mt-2"
        headingClassName="md:mx-4"
      />
      <CircleImageAndText
        imgSrc={phoneTwo}
        imgAlt="See parks and government land in the fishbrain app"
        headingText="Parks & government land"
        bodyText="Fishbrain has mapped millions of acres of government-owned land across the USA to help you identify public land and potential fishing access."
      />
      <Container className="mt-sm flex flex-col items-center sm:flex-row-reverse sm:justify-between md:justify-around">
        <div className="sm:w-col-5 md:w-col-4 flex w-full justify-start overflow-hidden">
          <NextImage
            alt="Fishing regulation made easy"
            className="size-full object-cover sm:mb-0"
            src={phoneOne}
            sizes="(min-width: 1680px) 507px,
                  (min-width: 600px) 40vw,
                  100vw"
          />
        </div>
        <div>
          <div className="sm:w-col-7 md:w-col-5 mt-6">
            <div className="flex gap-3">
              <BlueTickIcon size={32} />
              <Heading variant="sm">Fishing Regulations made easy</Heading>
            </div>
            <Text variant="lg" className="mt-4">
              Saltwater and freshwater fishing regulations with an easy to understand format. With a
              glance, know if a fish is in season, how many you can keep, how big they have to be,
              and more.
            </Text>
          </div>

          <div className="sm:w-col-7 md:w-col-5 mt-6">
            <div className="flex gap-3">
              <BlueCatchIcon size={32} />
              <Heading variant="sm">All the fishing hotspots</Heading>
            </div>
            <Text variant="lg" className="mt-4">
              Saltwater fishing regulations for Federal and State waters from Maine to Texas to
              Hawaii, and now includes freshwater for Florida, Alabama, Texas.
            </Text>
          </div>

          <div className="sm:w-col-7 md:w-col-5 mt-6">
            <div className="flex gap-3">
              <BlueGPSIcon size={32} />
              <Heading variant="sm">GPS controlled</Heading>
            </div>
            <Text variant="lg" className="mt-4">
              Fish Rules App uses your phone&apos;s GPS and calendar to show only the regulations
              you need. Out to sea with no signal? Manually select your fishing location to see
              relevant regulations.
            </Text>
          </div>
        </div>
      </Container>
      <AppDownloadSection />
    </div>
  );
};
